import { FETCH_DEVICES } from './constants'

export const fetchDevices = {
  request: () => ({ type: FETCH_DEVICES.REQUEST }),
  success: (devices) => ({ type: FETCH_DEVICES.SUCCESS, devices })
}
